/**
 * Centros aproximados dos estados brasileiros para o zoom inicial do mapa.
 * Fonte: capitais + centros geográficos oficiais (IBGE).
 * Formato: [longitude, latitude, zoom]
 */
export const UF_COORDS: Record<string, [number, number, number]> = {
  AC: [-70.5,  -9.0,   6],
  AL: [-36.6,  -9.6,   8],
  AM: [-64.0,  -4.0,   5],
  AP: [-51.5,   1.4,   7],
  BA: [-41.7, -12.5,   6],
  CE: [-39.3,  -5.2,   7],
  DF: [-47.9, -15.8,  10],
  ES: [-40.3, -19.6,   8],
  GO: [-49.3, -16.0,   7],
  MA: [-44.3,  -4.5,   6],
  MG: [-44.7, -18.5,   6],
  MS: [-54.5, -20.5,   6],
  MT: [-55.9, -12.6,   6],
  PA: [-52.0,  -3.5,   5],
  PB: [-36.9,  -7.2,   8],
  PE: [-37.9,  -8.3,   7],
  PI: [-42.8,  -7.8,   6],
  PR: [-51.6, -25.0,   7],
  RJ: [-43.2, -22.9,   9],
  RN: [-36.5,  -5.8,   8],
  RO: [-63.0, -10.8,   6],
  RR: [-61.4,   2.0,   6],
  RS: [-53.0, -30.0,   6],
  SC: [-50.0, -27.2,   7],
  SE: [-37.4, -10.6,   8],
  SP: [-48.5, -22.0,   7],
  TO: [-48.3,  -9.5,   6],
};

/** Brasil inteiro — fallback quando não há UF configurada */
export const BRAZIL_DEFAULT: [number, number, number] = [-47.9, -15.8, 4];
